import React, { memo, useEffect } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { createSelector } from 'reselect'

import { Grid, makeStyles } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '~/components/Header'

import { TYPES } from '~/actions'
import track from '~/track'

// styles (mui)
const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%'
  },
  wrapper: {
    zIndex: 102,
    position: 'absolute',
    left: 0,
    width: '100%',
    transition: '.3s ease'
  },
  headerBasket: {
    width: '100%',
    position: 'absolute',
    zIndex: 100
  },
  content: {
    transition: '.3s ease',
    background: theme.palette.background.paper,
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    ...theme.gofind.scrollBar
  },
  toggleMap: ({ view }) => ({
    padding: '8px 0',
    position: 'relative',
    transition: 'all 0.3s',
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 -1px 8px rgba(0, 0, 0, 0.29)',
    display: view === TYPES.VIEW_PRODUCTS ? 'none' : 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:after': {
      content: '""',
      position: 'absolute',
      inset: 0
    }
  }),
  overlay: {
    content: '""',
    position: 'absolute',
    inset: 0,
    zIndex: 0
  }
}))

const selectState = createSelector(
  (state) => state.app.mobileBottomShow,
  (state) => state.app.view,
  (showBottom, view) => ({ showBottom, view })
)

function Mobile({ children, config, dispatch, handleToggle, position, state, viewport }) {
  let dragTime
  const { view } = useSelector(selectState, shallowEqual)
  const classes = useStyles({ view })

  const getMapSize = (viewport) => viewport.height * 0.4
  const getFullMap = (viewport, view) => {
    const viewPage = [TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS].includes(view)

    return viewport.height - (viewPage ? 118 : 124)
  }

  useEffect(() => {
    if (view === TYPES.VIEW_PRODUCTS)
      dispatch({ current: getFullMap(viewport, view), offset: getFullMap(viewport, view) })
  }, [view])

  const handleTouchStart = (e) => {
    dispatch({
      initial:
        e.type === 'touchstart' ? e.touches[0].clientY - state.offset : e.clientY - state.offset,
      dragEnd: false,
      active: true
    })
  }

  const handleTouchEnd = () => {
    if (Math.abs(state.current - state.offset) < 20) return

    setTimeout(() => {
      const target = state.current - state.offset < 60 ? 0 : getFullMap(viewport, view) - 40

      dispatch({
        initial: state.current,
        active: false,
        current: target,
        offset: target,
        dragEnd: true,
        isListVisible: !!target
      })
    }, 100)
  }

  const handleTouchMove = (e) => {
    e.persist()

    window.requestAnimationFrame(() => {
      dragTime += 1

      if (dragTime < 2) return

      if (view === TYPES.VIEW_PRODUCTS) return

      if (state.active) {
        let current = 0

        if (e.type === 'touchmove') {
          current = e.touches[0].clientY - state.initial
        } else {
          current = e.clientY - state.initial
        }

        dispatch({ current })
      }
    })
  }

  const handleTrack = () => {
    if (view === 'VIEW_PRODUCTS') {
      if (state.current === getMapSize(viewport)) {
        return track('expandirMapaProduto', {
          category: 'mapa',
          name: 'products'
        })
      }

      return track('cliqueVerTodosOsProdutos', {
        category: 'mapa',
        name: 'all'
      })
    }

    if (state.current >= getMapSize(viewport)) {
      return track('expandirMapaLoja', { category: 'mapa', name: 'store' })
    }

    return track('cliqueVerTodasAsLojas', { category: 'mapa', name: 'all' })
  }

  const handleIncludeView = (view) => {
    return [TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS].includes(view)
  }

  const Icon = state.current > getMapSize(viewport) ? ExpandLessIcon : ExpandMoreIcon
  const isStateCurrentEqualsMapSize = state.current === getMapSize(viewport)

  const handlers = {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove
  }

  if (!position.user?.lat && !position.user?.lng) return null

  return (
    <>
      {!isStateCurrentEqualsMapSize && <Grid className={classes.overlay} />}

      <Grid className={classes.header} style={{ position: handleIncludeView(view) && 'relative' }}>
        <Header config={config} position={position} />
      </Grid>

      {view !== TYPES.VIEW_EMPTY && (
        <>
          <Grid
            id="bottom-wrap"
            className={classes.wrapper}
            style={{
              position: handleIncludeView(view) && 'relative',
              height: handleIncludeView(view) && '100%'
            }}
          >
            {[TYPES.VIEW_PRODUCTS, TYPES.VIEW_SEARCH_PRODUCTS, TYPES.VIEW_STORES].map((key) => {
              if (view === key) {
                return (
                  <Grid
                    key={key}
                    className={classes.content}
                    style={{
                      height: `${state.current}px`
                    }}
                  >
                    {children}
                  </Grid>
                )
              }
            })}

            <Grid {...handlers} onClick={handleTrack}>
              {!handleIncludeView(view) ? (
                <Grid className={classes.toggleMap} onClick={handleToggle}>
                  <Icon color="primary" />
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </>
      )}
    </>
  )
}

export default memo(Mobile)
